import React from "react";
import styled from "styled-components";
import { Prescription } from "common/models/types";
import OTCCard from "./OTCCard";

interface OTCHistoryProps {
  prescriptions: Prescription[];
  referenceChecker?: {
    [id: string]: {
      count: number;
      totalLength?: number;
      totalBytes?: number;
    };
  };
  onEdit?: (prescriptionId: number) => void;
  onDelete?: (prescriptionId: number) => void;
  type: "otc" | "hff"; // 표시할 타입 (일반의약품 또는 건강기능식품)
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const OTCHistory: React.FC<OTCHistoryProps> = ({
  prescriptions,
  referenceChecker,
  onEdit,
  onDelete,
  type,
}) => {
  // type에 따라 필터링된 prescriptions를 사용합니다.
  const filteredPrescriptions = prescriptions.filter((p) => p.type === type);

  return (
    <Container>
      {filteredPrescriptions.map((prescription) => (
        <OTCCard
          key={prescription.id} // id가 없다면 다른 key를 사용해야 합니다. (예: index, itemCode 등)
          prescription={prescription}
          referenceChecker={referenceChecker}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </Container>
  );
};

export default OTCHistory;
